import { useEffect, useState } from 'react';
import './App.css';
import Header from './Components/Header/Header';
import Products from './Products/Products';


function App() {

  return (
    <div className="App">
      <Header></Header>
      <Products></Products>
      <h4 >How React Work?</h4>
      <p>React. js is an open-source JavaScript library that is used for building user interfaces specifically for single-page applications. It's used for handling the view layer for web and mobile apps. React also allows us to create reusable UI components.
        React does not commit state changes one after the other if there are multiple state changes. Instead, React goes through its virtual DOM ,creates a list of those changes that need to be made to the actual DOM and then does it all in one single process.
        React reads these objects and uses them to create HTML elements on the virtual DOM, after which it gets synced with the real DOM. So we'll have trees of objects on the virtual DOM and trees of objects on the real DOM. React automatically updates the associated DOM element when we change data on a React element.</p>
      <br />
      <h4 >State Vs. Props</h4>
      <h6>Props</h6>
      <li>	Props are read-only.</li>
      <li>Props are immutable.</li>
      <li>Props allow you to pass data from one component to other components as an argument.</li>
      <li>Props can be accessed by the child component.</li>
      <h6>State</h6>
      <li>State changes can be asynchronous.</li>
      <li>State is mutable.</li>
      <li>State holds information about the components.</li>
      <li>Stateless components cannot have State.</li>
    </div >
  );
}

export default App;
